module.exports = __webpack_public_path__ + "static/media/img1-tc-mobile.d605e7c3.png";